
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from '../schema/QuestFormSchema';

interface QuestBasicInfoFieldsProps {
  form: UseFormReturn<FormValues>;
}

const QuestBasicInfoFields: React.FC<QuestBasicInfoFieldsProps> = ({ form }) => {
  const { t } = useTranslation(['admin', 'quests', 'common']);

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('admin:questName')}</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="type"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('admin:questType')}</FormLabel>
              <Select 
                onValueChange={field.onChange} 
                value={field.value}
              >
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder={t('admin:selectQuestType')} />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="daily">{t('quests:daily')}</SelectItem>
                  <SelectItem value="weekly">{t('quests:weekly')}</SelectItem>
                  <SelectItem value="special_event">{t('quests:specialEvent')}</SelectItem>
                  <SelectItem value="challenge">{t('quests:challenge')}</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('admin:questDescription')}</FormLabel>
            <FormControl>
              <Textarea 
                {...field} 
                rows={3}
                placeholder={t('admin:questDescriptionPlaceholder')}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default QuestBasicInfoFields;
